export const LoadingStates = {
  IDLE: "IDLE",
  PENDING: "PENDING",
  FINISHED: "FINISHED",
  ERROR: "ERROR",
};
